import ResourceForm from "../../components/Forms/ResourceForm/ResourceForm";

export default function NewResourcePage() {

    return (
        <ResourceForm method="POST"/>
    );
}


